export class AlfatronMukn {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.8';
        this.routes = [];
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /GET VER/i,
                callback: (match) => {
                    this.socket.send(`MX0404_N201_000 VER ${this.firmwareVersion}, ARM VER 1.8`);
                },
            },
            {
                name: 'getRoute',
                regExp: /GET MP hdmiout(\d+)/i,
                callback: (match) => {
                    var _a;
                    const output = parseInt(match[1], 10) - 1;
                    this.socket.send(`MP in${((_a = this.routes[output]) !== null && _a !== void 0 ? _a : 0) + 1} hdmiout${output + 1}`);
                },
            },
            {
                name: 'getRouteAll',
                regExp: /GET MP all/i,
                callback: (match) => {
                    var _a;
                    for (let i = 0; i < this.routes.length; i++) {
                        this.socket.send(`MP hdmiin${((_a = this.routes[i]) !== null && _a !== void 0 ? _a : 0) + 1} hdmiout${i + 1}`);
                    }
                },
            },
            {
                name: 'setRoute',
                regExp: /SET SW (?:hdmi)?in(\d+) (?:hdmi)?out(\d+)/i,
                callback: (match) => {
                    const input = parseInt(match[1], 10) - 1;
                    const output = parseInt(match[2], 10) - 1;
                    this.routes[output] = input;
                    this.socket.send(`SW hdmiin${input + 1} hdmiout${output + 1}`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.routes.length = 0;
        for (const videoOutput of Object.values((_a = config.videoOutputs) !== null && _a !== void 0 ? _a : {})) {
            this.routes[parseInt(videoOutput.code, 10) - 1] = 0;
        }
    }
}
AlfatronMukn.emulatorType = 'socketEmulator';
AlfatronMukn.key = '-MluysLKMOwqXPlUzGLg';
